import { makeAutoObservable } from 'mobx';

import { Context } from '@/common/constants/context';
import { setupPresetGroupRepository } from '@/media/repository/SetupPresetGroupRepository';
import { setupPresetRepository } from '@/media/repository/SetupPresetRepository';
import { ProductType } from '@/product/constants/productTypes';

import { DefaultViewTemplate } from '../constants/defaultViewTemplates';
import ViewTemplate from '../entity/ViewTemplate';

class ViewTemplateRepository {
  viewTemplates: ViewTemplate[] = [];

  /*
   * Typing here is totally broken
   *
   * Value "viewTemplatesData" goes from "src/Model/ViewTemplates.php" on backend,
   * need to review this file, understand its goal and update types
   * */
  initViewTemplates = (viewTemplatesData: Any[]) => {
    this.viewTemplates = viewTemplatesData.map(
      (d) => new ViewTemplate(
        d,
        setupPresetRepository.findSetupPresetById(d.setupPreset),
        setupPresetGroupRepository.findSetupPresetGroupById(d.setupPresetGroup),
      ),
    );
  };

  constructor() {
    makeAutoObservable(this, {});
  }

  findViewTemplateById(id: number) {
    if (!this.viewTemplates || this.viewTemplates.length === 0) {
      return null;
    }

    return this.viewTemplates?.find((sp) => sp.id === id) ?? null;
  }

  findViewTemplates(productType: ProductType, context: Nullable<number> = null) {
    const spType = ViewTemplate.getTypeByProductType(productType);

    const viewTemplatesFilteredByProductType = this.viewTemplates.filter((vt) => vt.type.includes(spType));

    if (!context) {
      return viewTemplatesFilteredByProductType;
    }

    return viewTemplatesFilteredByProductType.filter((vt) => vt.context.includes(context));
  }

  getDefaultViewTemplateId(productType: ProductType, context = Context.Listing) {
    if (productType === ProductType.Rough || productType === ProductType.LGDRough) {
      if (context === Context.B2B) {
        return DefaultViewTemplate.RoughEdit;
      }

      return DefaultViewTemplate.Rough;
    }

    if (productType === ProductType.Jewelry) {
      if (context === Context.B2B) {
        return DefaultViewTemplate.JewelryEdit;
      }

      return DefaultViewTemplate.Jewelry;
    }

    if (productType === ProductType.Gem) {
      if (context === Context.B2B) {
        return DefaultViewTemplate.GemEdit;
      }

      return DefaultViewTemplate.Gem;
    }

    if (productType === ProductType.DiamondFancy || productType === ProductType.LGDFancy) {
      if (context === Context.B2B) {
        return DefaultViewTemplate.FancyEdit;
      }

      return DefaultViewTemplate.Fancy;
    }

    if (context === Context.B2B) {
      return DefaultViewTemplate.ColorlessEdit;
    }

    return DefaultViewTemplate.Colorless;
  }
}

export const viewTemplateRepository = new ViewTemplateRepository();
